import React from 'react';

import Avatar from 'components/Avatar';

import './styles.css';

const TenantCard = ({tenant}) => (
  <div className="TenantCard">
    <Avatar
      className="tenantAvatar"
      url={tenant.internalAvatarCropped || tenant.avatarCropped}
      initials={tenant.initials}
    />
    <div className="tenantInfo">
      <div className="name">{tenant.fullName}</div>
      <div className="email">{tenant.email}</div>
      <div className="phone">{tenant.phoneNumber || 'No phone available'}</div>
    </div>
  </div>
);

export default TenantCard;
